<template>
    <section class="section-card mb-2">
        <div class="section-card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Room Summary</h4>
            <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('onSelectRooms')">Select Rooms</button>
        </div>
        <div class="section-card-body">
            <div class="table-responsive mb-2" v-if="rooms.length">
                <table class="table table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>Room</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(room, index) in rooms" :key="room.service_resource_id">
                            <td>{{ room.name }}</td>
                            <td>
                                <input v-model="room.rate" type="number" min="0" class="form-control form-control-sm"/>
                            </td>
                            <td>{{ roomAmount(room) }}</td>
                            <td>
                                <button type="button" class="btn btn-sm btn-outline-danger" @click="removeRoomAt(index)">x</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Total: {{ total }}</h5>
                <button type="button" class="btn btn-primary" :disabled="saving" @click="onSave">Checked-In</button>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    modelValue: {
        type: Array,
        required: true,
    },
    nights: {
        type: Number,
        required: true,
    },
    checkIn: {
        type: String,
        default: null,
    },
    checkOut: {
        type: String,
        default: null,
    },
    saving: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue', 'onSelectRooms', 'onSave']);
const showError = inject('showError');

const rooms = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
});

const roomAmount = (room) => {
    return Number(room.rate) * props.nights;
};

const total = computed(() => {
    let sum = 0;
    for (const room of rooms.value) {
        sum += Number(room.rate) * props.nights;
    }
    return sum;
});

const removeRoomAt = (index) => {
    if (rooms.value.length <= 1) {
        showError('Reservation must have at least one room.');
        return;
    }
    rooms.value.splice(index, 1);
};

const validate = () => {
    if (! rooms.value.length) {
        showError('Reservation must have at least one room.');
        return false;
    }
    if (! props.checkIn) {
        showError('Please select check-in date');
        return false;
    }
    if (! props.checkOut) {
        showError('Please select check-out date');
        return false;
    }
    if (new Date(props.checkOut) <= new Date(props.checkIn)) {
        showError('Check-out date must be after check-in date');
        return false;
    }
    const zeroRateRoom = rooms.value.find(room => Number(room.rate) <= 0);
    if (zeroRateRoom) {
        showError('Please set a rate for every selected room.');
        return false;
    }
    return true;
};

const onSave = () => {
    if (! validate()) return;
    emit('onSave');
};
</script>
